module.exports = __webpack_public_path__ + "img/41.51bf1eb6.jpg";